export default __webpack_public_path__ + "static/media/pdf.c4330268.svg";